import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import '../../assets/css/component/Input.css'

class Password extends Component {
    render() {
        const { label_name, placeholder, name, value, onChange, onBlur, error } = this.props;

        return (
            <>
                <Form.Group className="mb-2">
                    <Form.Label className='form_label'>{label_name}</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder={placeholder}
                        className='form_input'
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                    {error}
                </Form.Group>
            </>
        );
    }
}

export default Password;
